export const EmoteTag = {
    default: 'default',
    nms: 'nms',
    satisfactory: 'satisfactory',
    eddison: 'eddison',
    other: 'other',
}